<template>
	<v-container class="login-container">
		<!-- 로그인 화면 로고 -->
		<v-layout class="login-layout" wrap justify-center>
			<!-- <v-flex xs12 style="margin-bottom:80px; margin-top:100px;">
				<div class="text-center"></div>
			</v-flex> -->
			<!-- CDP -->

			<v-layout class="login_background" flex-wrap justify-center align-center>
				<v-flex xs6>
					<div>
						<v-img height="100vh" src="/image/login_bg.png"></v-img>
					</div>
				</v-flex>
				<v-flex xs6>
					<div style="width:320px; padding:0px 10px">
						<p class="login-yellow">상담사 로그인</p>
						<p class="login-grey">로그인이 필요한 서비스입니다.</p>
						<div class="text-center" style="margin: 0 auto; width:320px;">
							<!-- 아이디 -->
							<v-text-field
								:error-messages="iderrorMessages"
								:autofocus="false"
								label="아이디"
								maxlength="255"
								height="50px"
								outlined
								:hideDetails="iderrorMessages === '' ? true : false"
								flat
								v-model="userid"
								@keydown.enter="login()"
								autocomplete="off"
								:class="iderrorMessages === '' ? 'mb-4' : ''"
							></v-text-field>
							<!-- 비밀번호 -->
							<v-text-field
								:error-messages="pwerrorMessages"
								:autofocus="false"
								label="비밀번호"
								type="password"
								height="50px"
								outlined
								:hideDetails="pwerrorMessages === '' ? true : false"
								maxlength="255"
								v-model="password"
								@keydown.enter="login()"
								autocomplete="off"
								:class="pwerrorMessages === '' ? 'mb-4' : ''"
							></v-text-field>
							<!-- 로그인 버튼 -->
							<v-checkbox v-model="rememberId" color="MainColor1" :label="`아이디 저장`" class="mt-0 pt-0" hideDetails></v-checkbox>
							<v-btn class="loginButton" block elevation="0" @click="login()">
								<span style="color:white;	font-weight: bold;">
									로그인
								</span>
							</v-btn>
							<!-- <p class="footer-text">Don't have an account? <span class="signup-text" @click="toSignup">Sign Up</span></p> -->
						</div>
					</div>
				</v-flex>
			</v-layout>
			<!-- 하단 -->
		</v-layout>
		<alertModal2 :setdialog="alertModal2"></alertModal2>
	</v-container>
</template>

<script>
import { alertModal2 } from '@/components'
export default {
	components: {
		alertModal2,
	},
	data() {
		return {
			rememberId: false,
			alertModal2: {
				dialog: false,
				text: '',
			},
			// 아이디 에러메세지
			iderrorMessages: '',
			// 패스워드 에러메세지
			pwerrorMessages: '',
			// id,password 데이터
			userid: '',
			password: '',
			reservedayData: {},
		}
	},
	created() {
		const data = {
			code: this.$route.params.code,
		}
		this.$store.dispatch('reservedays', data).then(day => {
			this.reservedayData = day.data.reservedays[0]
		})

		if (localStorage.getItem('cu-loginId')) {
			this.userid = localStorage.getItem('cu-loginId')
			this.rememberId = true
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		login() {
			if (!this.userid) {
				this.iderrorMessages = 'Please enter your ID.'
				return
			} else if (!this.password) {
				this.pwerrorMessages = 'Please enter your PASSWORD.'
				return
			} else {
				const data = {
					counselorid: this.userid,
					counselorpw: this.password,
					business: this.reservedayData.business.id,
				}
				const codes = ['09buhz2luv1', '3gsaczjfjck']
				if (!codes.includes(this.$route.params.code)) data.code = this.$route.params.code
				else data.code = 'wvoe1vyzao'
				this.$store
					.dispatch('counselors', data)
					.then(res => {
						if (this.rememberId) localStorage.setItem('cu-loginId', this.userid)
						if (res.data.counselors.length > 0) {
							this.$router
								.push({
									name: 'COUNSELORPAGE_RESERVE',
									params: {
										code: this.$route.params.code,
										biz: this.reservedayData.business.id,
									},
								})
								.catch(() => {})
							this.$store.commit('counserlorLoginData', res.data.counselors[0])
						} else {
							this.iderrorMessages = 'Your ID or Password is incorrect.'
							this.pwerrorMessages = 'Your ID or Password is incorrect.'
						}
					})
					.catch(() => {})
			}
		},
	},
}
</script>
<style lang="scss"></style>
